import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/Clinical-Patient`;

export const getClinicalPatients = async ({
  locationId,
  pcpName,
  gender,
  memberId,
  memberFullName,
  filterAdmitted,
  filterDischarged,
  filterEmergency,
  filterHighCost,
  filterHighRisk,
  pageNumber = 1,
  pageSize = 50
}) => {
  try {
    const params = {
      locationId,
      pcpName,
      gender,
      memberId,
      memberFullName: memberFullName ? memberFullName.toUpperCase() : memberFullName,
      filterAdmitted,
      filterDischarged,
      filterEmergency,
      filterHighCost,
      filterHighRisk,
      page: pageNumber,
      pageSize
    };

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching clinical patients:", error);
    throw error;
  }
};
